module.exports = __webpack_public_path__ + "img/1.28b917ce.jpg";